import style from './Search.module.css'
import {ReactComponent as Close} from '../../Assets/icons/close.svg'
import { ReactComponent as Search } from '../../Assets/icons/search-icon.svg'
import { useEffect, useRef } from 'react'
import { useState } from 'react'


export default function SearchSelect({setSelectOptions, options}) {
    const ref = useRef(null)
    const [value, setValue] = useState('')

    useEffect(() => {    
        setSelectOptions(options.filter(elem => elem?.name?.toLowerCase().includes(value?.toLowerCase())))
        // eslint-disable-next-line
    }, [value])

    return <div className={`${style.container} inputContainer`}>
        {<button className={style.close} onClick={() => setValue('')}>{value === '' ? <Search className='inputContainer'/> : <Close className='inputContainer'/>}</button>}
        <input ref={ref} type="text" onFocus={(e) => e.target.scrollIntoView({behavior: 'smooth', block: 'center'})} value={value} onChange={(e) => setValue(e.target.value)} />
    </div>
}